import React from "react";

import PageName from "../../shared/components/PageName";
import DataTable from "../../shared/components/table/DataTable";

import eventDatas from "../../../home/extraCurricular/utils/eventDatas";

const EventsPage = () => {
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      width: "5%",
      editable: false,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: "30%",
      editable: true,
    },
    {
      title: "Data",
      dataIndex: "date",
      width: "30%",
      editable: true,
    },
    {
      title: "Grade",
      dataIndex: "grade",
      width: "20%",
      editable: true,
    },
  ];

  return (
    <div>
      <PageName pageName="Events" totalRecords={eventDatas} />
      <DataTable tableData={eventDatas} columns={columns} />
    </div>
  );
};

export default EventsPage;
